import './SendOrderToCustomer.scss';

import PropTypes, { array } from 'prop-types';
import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Formik } from 'formik';
import { deepCopy } from '@utils/utility';
import { Text, Link } from '@sitecore-jss/sitecore-jss-react';
import SendOrderToCustomerModel from './Models/SendOrderToCustomerModel';
import CPPageHeader from '../CPPageHeader';
import * as Yup from 'yup';
import Message from '@components/Share/Message';
import Global from '@utils/global';
import SendOrderToCustomerModal from './SendOrderToCustomerModal/index';
import { sendSaleOrder } from '@redux/actions/cpSendSaleOrder';
import { getCurrentSOCart } from '@redux/actions/product';
const SendOrderToCustomer = ({ fields }) => {
  const dispatch = useDispatch();
  const contactData = useSelector((state) => state?.clientTellingPortalCustomer?.contacts[0]?.json_facet);
  const messageObj = useSelector((state) => state.getMessageReducer.objMessages);
  const isSuccess = useSelector((state) => state?.cpSendSaleOrderReducer?.isSuccess);
  const dataSOCart = useSelector((state) => state?.productReducer?.cartDetailReducer?.currentCart);
  const [layoutData, setLayoutData] = useState(null);
  const [isShow, setShow] = useState(false);
  const [email, setEmail] = useState(true);
  const [emailAdd, setEmailAdd] = useState(false);
  const [SMS, setSMS] = useState(false);
  const [SMSAdd, setSMSAdd] = useState(false);
  const [inputEnter, setInputEnter] = useState('');
  const [typeAddEvent, setTypeAddEvent] = useState('');
  const [indexEvent, setIndexEvent] = useState(0);
  const [isHandleEdit, setIsHandleEdit] = useState(false);
  const [arrEmail, setArrEmail] = useState([]);
  const [arrSMS, setArrSMS] = useState([{ name: 'SMS', value: '' }]);
  const [quantityPackage, setQuantityPackage] = useState('');

  const [schema, setSchema] = useState(
    Yup.object({
      firstName: Yup.string()
        .required(<Message messageCode='Msg_001.1' />)
        .matches(Global.nameValidateRegex(), messageObj?.['Msg_001.1'])
        .trim(),
      lastName: Yup.string()
        .required(<Message messageCode='Msg_001.2' />)
        .matches(Global.nameValidateRegex(), messageObj?.['Msg_001.2'])
        .trim(),
      // email: Yup.boolean().oneOf([true], <Message messageCode='Msg_015' />)
    })
  );

  const initialValues = useMemo(() => {
    return {
      firstName: contactData?.Personal?.FirstName || '',
      lastName: contactData?.Personal?.LastName || '',
      email: {
        email1: true,
        email2: ''
      },
      emailValue: {
        emailValue1: contactData?.Email?.PreferredEmail?.SmtpAddress || '',
        emailValue2: ''
      },
      SMS: {
        SMS1: '',
        SMS2: ''
      },
      SMSValue: {
        SMSValue1: '',
        SMSValue2: ''
      }
    };
  }, [contactData]);

  const onShowHandler = () => {
    setShow(true);
  };

  const onCloseHandler = () => {
    setShow(false);
  };

  const handleAdd = (evt) => {
    evt.preventDefault();
    onShowHandler();
    setTypeAddEvent(evt.target.getAttribute('type'));
    setIsHandleEdit(false);
  };

  const handleEdit = (evt) => {
    evt.preventDefault();
    onShowHandler();
    setIndexEvent(evt.target.getAttribute('index'));
    setIsHandleEdit(true);
  };

  const handleRemove = (evt) => {
    evt.preventDefault();
    if (evt.target.getAttribute('type') === 'email') {
      setArrEmail([]);
    } else if (evt.target.getAttribute('type') === 'SMS') {
      if (arrSMS.length > 1) {
        setArrSMS(arrSMS.filter((i, idx) => idx !== +evt.target.getAttribute('index')));
      } else {
        setArrSMS([{ name: 'SMS', value: '' }]);
      }
    }
  };

  const handleSave = (evt) => {
    evt.preventDefault();
    if (typeAddEvent === 'email' && !!inputEnter) {
      setArrEmail([{ name: 'Email', value: inputEnter }]);
    } else if (typeAddEvent === 'SMS' && !!inputEnter) {
      if (isHandleEdit) {
        arrSMS[indexEvent].value = inputEnter;
      } else {
        if (arrSMS.length < 2) {
          if (arrSMS[0].value === '') {
            arrSMS[0].value = inputEnter;
          } else {
            arrSMS.push({ name: 'SMS', value: inputEnter });
          }
        }
      }
    }
    setInputEnter('');
    setShow(false);
  };

  const handleSend = (values) => {
    dispatch(
      sendSaleOrder({
        cartName: dataSOCart?.Name,
        firstName: values?.firstName,
        lastName: values?.lastName,
        sendEmail: values?.email?.email1 === true || values?.email?.email2 === true ? true : false,
        emailAddresses: `${values?.emailValue?.emailValue1}, ${values?.emailValue?.emailValue2}`,
        sendSms: values?.SMS?.SMS1 === true || values?.SMS?.SMS2 === true ? true : false,
        phoneNumbers: `${values?.SMSValue?.SMSValue1}, ${values?.SMSValue?.SMSValue2}`
      })
    );
    if (isSuccess) {
      window.location.href = layoutData['Send sale order link']?.value?.href;
    }
  };

  useEffect(() => {
    setLayoutData(new SendOrderToCustomerModel().getData(deepCopy(fields)));

    dispatch(getCurrentSOCart());
  }, []);

  useEffect(() => {
    if (dataSOCart) {
      const packages = dataSOCart?.Lines?.filter((item) => item?.Package?.PackageId);
      setQuantityPackage(packages.length + 1)
    }
  }, [dataSOCart]);

  return (
    layoutData && (
      <>
        <CPPageHeader title={'Send Sales Order to [Customer name]'} />
        <div className='send-order-customer'>
          <div className='container'>
            <div className='send-order-customer__wrapper'>
              <div className='send-order-customer__head'>
                <h3 className='send-order-customer__head__title'>{layoutData?.Header?.value.replace('{orderId}', dataSOCart?.SalesOrderId)}</h3>
                <p className='send-order-customer__head__info'>
                  {layoutData?.['Creation and Expiration text']?.value
                    .replace('{createDate}', Global.formatDateDDMMMYYYY(dataSOCart?.CreateDate))
                    .replace('{expireDate}', Global.formatDateDDMMMYYYY(dataSOCart?.ExpiredDate))}
                </p>
                <p className='send-order-customer__head__info'>
                  {layoutData?.['Number of packages text']?.value.replace('{packagesNumber}', quantityPackage)}
                </p>
                <Text field={layoutData?.['Additional text']} tag='p' className='send-order-customer__head__info' />
              </div>
              <div className='send-order-customer__content'>
                <Formik initialValues={initialValues} validationSchema={schema} onSubmit={(values) => handleSend(values)} enableReinitialize={true}>
                  {({ errors, touched, handleChange, values, setFieldValue }) => (
                    <Form className='send-order-customer__content__form'>
                      <div className='form-group'>
                        <input
                          id='firstName'
                          className={'form-control'}
                          name='firstName'
                          type='text'
                          onChange={handleChange}
                          value={values.firstName}
                          placeholder={'FirstName'}
                        />
                        <label htmlFor='firstName' className='form-group__label'>
                          <Text field={{ value: 'FirstName' }} />
                        </label>
                        {errors.firstName && touched.firstName && <span className='error-validate'>{errors.firstName}</span>}
                      </div>
                      <div className='form-group'>
                        <input
                          id='lastName'
                          className={'form-control'}
                          name='lastName'
                          type='text'
                          onChange={handleChange}
                          value={values.lastName}
                          placeholder={'LastName'}
                        />
                        <label htmlFor='lastName' className='form-group__label'>
                          <Text field={{ value: 'LastName' }} />
                        </label>
                        {errors.lastName && touched.lastName && <span className='error-validate'>{errors.lastName}</span>}
                      </div>
                      <div className='form-group form-group--checkbox'>
                        <div className='form-group-left'>
                          <div className='osim-checkbox'>
                            <input
                              id='email'
                              className={'osim-checkbox-input'}
                              name='email'
                              type='checkbox'
                              checked={email}
                              onClick={() => setEmail(!email)}
                              readOnly
                            />
                            <label
                              className='osim-checkbox-label'
                              onClick={() => {
                                setEmail(!email);

                                setFieldValue('email.email1', !email);
                              }}
                            >
                              {`${layoutData?.Email?.value}(${contactData?.Email?.PreferredEmail?.SmtpAddress})`}
                            </label>
                          </div>
                        </div>
                        <div className='form-group-right'>
                          {arrEmail.length === 0 && (
                            <button className='form-group-right__btn' type='email' onClick={handleAdd}>
                              <Text field={layoutData?.['Add new']} />
                            </button>
                          )}
                        </div>
                      </div>
                      {arrEmail.length > 0 &&
                        arrEmail.map((item, index) => {
                          return (
                            <div key={index} className='form-group form-group--checkbox'>
                              <div className='form-group-left'>
                                <div className='osim-checkbox'>
                                  <input
                                    id='email'
                                    className={'osim-checkbox-input'}
                                    name='email'
                                    type='checkbox'
                                    checked={emailAdd}
                                    onClick={() => setEmailAdd(!emailAdd)}
                                    readOnly
                                  />
                                  <input hidden id='emailAddValue' name='emailAddValue' readOnly />
                                  <label
                                    className='osim-checkbox-label'
                                    onClick={() => {
                                      setEmailAdd(!emailAdd);

                                      setFieldValue('email.email2', !emailAdd);
                                      setFieldValue('emailValue.emailValue2', item.value);
                                    }}
                                  >
                                    {`${item.name}(${item.value})`}
                                  </label>
                                </div>
                              </div>
                              <div className='form-group-right'>
                                {arrEmail.length > 0 && (
                                  <div className='form-group-right__box'>
                                    <button className='form-group-right__btn' type='email' onClick={handleEdit}>
                                      <Text field={layoutData?.Edit} />
                                    </button>
                                    <button className='form-group-right__btn' type='email' index={index} onClick={handleRemove}>
                                      <Text field={layoutData?.Remove} />
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      {arrSMS.length > 0 &&
                        arrSMS.map((item, index) => {
                          return (
                            <div key={index} className='form-group form-group--checkbox'>
                              <div className='form-group-left'>
                                <div className='osim-checkbox'>
                                  <input
                                    id='SMS'
                                    className={'osim-checkbox-input'}
                                    name='SMS'
                                    type='checkbox'
                                    checked={index == 0 ? SMS : SMSAdd}
                                    onClick={() => (index == 0 ? setSMS(!SMS) : setSMSAdd(!SMSAdd))}
                                    readOnly
                                  />
                                  <label
                                    className='osim-checkbox-label'
                                    onClick={() => {
                                      index == 0 ? setSMS(!SMS) : setSMSAdd(!SMSAdd);
                                      index == 0 ? setFieldValue('SMS.SMS1', !SMS) : setFieldValue('SMS.SMS2', !SMSAdd);
                                      index == 0 ? setFieldValue('SMSValue.SMSValue1', item.value) : setFieldValue('SMSValue.SMSValue2', item.value);
                                    }}
                                  >
                                    {`${item.name}(${item.value})`}
                                  </label>
                                </div>
                              </div>
                              <div className='form-group-right'>
                                {arrSMS.length === 1 ? (
                                  item.value === '' ? (
                                    <button className='form-group-right__btn' type='SMS' onClick={handleAdd}>
                                      <Text field={layoutData?.['Add new']} />
                                    </button>
                                  ) : (
                                    <div className='form-group-right__box'>
                                      <button className='form-group-right__btn' type='SMS' index={index} onClick={handleEdit}>
                                        <Text field={layoutData?.Edit} />
                                      </button>
                                      <button className='form-group-right__btn' type='SMS' index={index} onClick={handleRemove}>
                                        <Text field={layoutData?.Remove} />
                                      </button>
                                      <button className='form-group-right__btn' type='SMS' onClick={handleAdd}>
                                        <Text field={layoutData?.['Add new']} />
                                      </button>
                                    </div>
                                  )
                                ) : (
                                  <div className='form-group-right__box'>
                                    <button className='form-group-right__btn' type='SMS' index={index} onClick={handleEdit}>
                                      <Text field={layoutData?.Edit} />
                                    </button>
                                    <button className='form-group-right__btn' type='SMS' index={index} onClick={handleRemove}>
                                      <Text field={layoutData?.Remove} />
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      {/* {errors.email && touched.email && <span className='error-validate'>{errors.email}</span>} */}
                      <SendOrderToCustomerModal
                        isShow={isShow}
                        onCloseHandler={onCloseHandler}
                        onHandleSave={handleSave}
                        onSetInputEnter={setInputEnter}
                        onLayoutData={layoutData}
                        onInputEnter={inputEnter}
                      />
                      <div className='form-btn'>
                        <button className='btn btn-primary form-btn__send' type='submit'>
                          <Text field={layoutData?.['Send sale order']} />
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
                <div className='send-order-customer__content__link-back'>
                  <Link field={layoutData?.['Back to sale cart link']} className='btn-link'>
                    <Text field={layoutData?.['Back to sale cart']} />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  );
};

SendOrderToCustomer.prototype = {
  fields: PropTypes.any
};

export default SendOrderToCustomer;
